import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';

import useAppModal from 'hooks/useAppModal';
import useAppSelector from 'hooks/useAppSelector';
import { SystemTemplates } from 'models/automation/SystemTemplates';
import useSystemTemplatesEditModal, {
  SYSTEM_TEMPLATE_EDIT_MODAL_ID,
} from './modal/edit/useSystemTemplatesEditModal';

const SystemTemplatesTabModal = () => {
  const { key } = useParams();
  const hasInit = useRef(false);
  const activeModals = useAppSelector((state) => state.modal.activeModals);
  const { closeModal } = useAppModal();
  const { openSystemTemplateEditModal } = useSystemTemplatesEditModal();

  useEffect(() => {
    // If the modal is not open, but we're currently at the modal route, we
    // automatically open it.
    if (
      key &&
      !activeModals[SYSTEM_TEMPLATE_EDIT_MODAL_ID] &&
      key in SystemTemplates &&
      !hasInit.current
    ) {
      openSystemTemplateEditModal({ key: key as SystemTemplates });
      hasInit.current = true;
    }
  }, [key, activeModals]);

  useEffect(() => {
    return () => {
      // If the modal is open but this route is unmounting we automatically
      // close it.
      if (hasInit.current) {
        closeModal(SYSTEM_TEMPLATE_EDIT_MODAL_ID);
        hasInit.current = false;
      }
    };
  }, []);

  return null;
};

export default SystemTemplatesTabModal;
